module.exports = __webpack_public_path__ + "static/img/frack2.1820a51f.png";